<template>

<div class="pc_only">
       <h2 class="kojin-title">
        {{title}}</h2>
     </div>
     
     <span class="sp_only">
       <span class="sp-title" style="color:#FFF;background: #4169e1;">
           {{title}}
          <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
         </span>
       </span>

       
       <div  align='left' style='margin:20px; background-color: #f0ebf8;padding: 3%;'>
          <div v-for="part in allparts" :key="part.kind" class="answer_area">
            
            <div v-if="part.kind=='form_title'" class="title_set form-check form-check-inline">
                <font size="6pt"><b>{{ part.label }}</b></font><br/>
            </div>
            <div v-if="part.kind=='form_sub_title'" class="title_set form-check form-check-inline" style="font-size:0.95rem">
                <b>{{ part.label }}</b><br/>
            </div>
            <div v-if="part.kind=='footer'" class="title_set form-check form-check-inline" style="font-size:0.95rem">
                <b>{{ part.label }}</b><br/>
            </div>
            <div v-if="part.kind=='title_large'" class="title_set form-check form-check-inline">
              <font size="6pt"><b>{{ part.label }}</b></font><br/>
            </div>
            <div v-if="part.kind=='title'" class="title_set form-check form-check-inline" style="font-size:0.95rem">
                <b>{{ part.label }}</b><br/>
            </div>
            
            <div v-if="part.kind=='image'" class="section_area form-check form-check-inline">
                <b>{{ part.label }}</b> <b v-if="part.hissu == 1" style="color:red">（必須）</b><br>
                <!--
                <input type="file" accept="image/*" :id="part.index" v-on:change="imgUpload"  /><br/>
                -->
              <span v-for="image in part.option" :key="image">
                <input type='file' :id="image.index" :name="part.index" accept="image/*" v-on:change="imgUpload" style="margin:5px 0" /><br/>
              </span>
            </div>
            <div v-if="part.kind=='text'" class="section_area form-check form-check-inline">
                <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                <br><textarea cols="40" rows="3" v-on:change="setText(part.index)" v-model="answer[part.index]" class="form-control" ></textarea><br/>
            </div>
            <div v-if="part.kind=='date'" class="section_area form-check form-check-inline">
                <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                <br><input type="date" size="20" v-on:change="setDate(part.index)" v-model="answer[part.index]" class="form-control" /><br/>
            </div>
            <div v-if="part.kind=='time'" class="section_area form-check form-check-inline">
                <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
                <br><input type="time" size="20" v-on:change="setTime(part.index)" v-model="answer[part.index]" class="form-control" /><br/>
            </div>
            
            <div v-if="part.kind=='check_title'" class="section_area form-check form-check-inline">
              <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
              <br>
              <div v-for="part2 in allparts" :key="part2.kind">
                <template v-if="part.seq == part2.group_seq" >
                  <div style="display: flex;align-items: center;">
                      <input type="checkbox" style="margin:0 0.5rem;" class="form-check-input"  :name="'checkbox-' + part2.id" v-on:change="setCheckbox(part2,part)" v-model="ans_checkbox[part2.index]" >
                      
                      <span :for="'checkbox-' + part2.id" style="float:right" >{{ part2.label }}</span>
                  </div>
                  <span v-for="check in part2.child" :key="check">
                      <div style="margin-left:15px">
                        <span v-if="check[2] == 1" >
                          <b>{{ check[1] }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b><br>
                          <input style="width:95%" class="form-control"  type="text" v-if="check[0] == 'text' " v-model="ans_childcheck[part2.index]" v-on:change="setChildCheck(check[3],part2.index)" >
                        </span>
                      </div>
                  </span>
                </template>
              </div>
            </div>
            
            <div v-if=" part.kind=='radio_title'" class="section_area form-check form-check-inline">
              <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
              <br>
              <div v-for="part2 in allparts" :key="part2.kind">
                <template v-if="part.seq == part2.group_seq" >
                  <span >
                    <input type="radio" class="form-check-input"  v-on:change="setRadio(part2,part)" v-model="ans_radio" :name="part2.seq"  style="margin-left:0.5rem;margin-right:5px">
                    <span :for="'radio-' + part2.id">{{ part2.label }}</span>
                        
                  </span>
                  <span v-for="radio in part2.child" :key="radio">
                     <div style="margin-left:15px">
                          <span v-if="radio[2] == 1" >
                           <b>{{ radio[1] }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b><br>
                           <input type="text"  style="width:95%" class="form-control"  v-if="radio[0] == 'text' "  v-model="ans_childradio[part2.index]" v-on:change="setChildRadio(radio[3],part2.index)" >
                       </span>
                    </div>
                  </span>
                </template>
              </div>
            </div>
            <div v-if="part.kind=='pulldown'" class="section_area form-check form-check-inline">
                <b>{{ part.label }}</b><b v-if="part.hissu == 1" style="color:red">（必須）</b>
              <select class="form-select" v-on:change="setPulldown('pulldown-' + part.id,part.index)" :id="'pulldown-' + part.id">
                <option v-for="op in part.option" :key="op">{{op}}</option>
              </select>
            </div>
          </div>
        </div>
        <div style="width: 100%;text-align: center;">
            <button  class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-on:click="teishutsu_kakunin" >提出する</button>
        </div>
                 
    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                v-on:call="call"
                v-on:close_message="Close_message"
                v-on:ok_message="OK_message"/>

  </template>
  
  <script setup>
  /* eslint-disable */
    import { ref } from 'vue';
    import { GlobalData, DateSetting,TimeSetting,DateTimeSetting,login_check } from '../js/userdata.js'
    import AWS from 'aws-sdk';
    
    import { useRouter,useRoute } from 'vue-router'
    import axios from 'axios'
    const url = GlobalData.$API_URL
    const router = useRouter();
    const route = useRoute();

    /* メッセージを表示するモーダルウィンドウ */
    import MessageModal from '../common/MessageModal.vue'  

  let message = ref("")//表示するメッセージ
  let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
  let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
  let message_flag = ref(false)//表示・非表示フラグ

  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント

//  const mode = ref('read');
  const ans_text = ref('');
  const ans_date = ref('');
  const ans_time = ref('');
  const ans_checkbox = ref([]);
  const ans_radio = ref('on');
  const ans_pulldown = ref('');
  const ans_childcheck = ref([]);
  const ans_childradio = ref([]);
  let allparts = ref([]);

  
// 親コンポーネントへ送るemit
const emit = defineEmits(['call'])

// 親コンポーネント（ShakyoForm.vue）から送られてきた値
const props = defineProps(['param']);

let results = props.param.results


let title = "活動報告書の提出"
let form_no = props.param.form_no
//alert(form_no)
let form_syurui = props.param.form_syurui
let form_syurui_text = "report"
let program_id = 0

  if(form_syurui == 1){
    form_syurui_text = "enqete"
    title = "アンケート提出"
  }else{
    program_id = props.param.program_id
  }

  // 画像アップロード中フラグ（）
  let image_upload_flg = ref(false)
    
  //-------- CSVから配列へ変換する ----------------------------------------

  let csv1 = []; // 種類
  let csv2 = []; // テキスト
  let csv3 = []; // 必須フラグ
  let csv4 = [];
  const kaito = (fileContent) => {
      
    // アンケート・報告書の内容がない時
    if(fileContent == undefined){

      let set_message = "活動報告書"
      if(form_syurui == 1){
        set_message = "アンケート"
      }
        message.value = set_message+"の回答が用意されておりません。所属社協へお問い合わせください。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "not_form";
        contentMessage.value = MessageModal
        return
    }
    let csv = fileContent.split("\n");
    csv1 = csv[1].split(" ").filter(Boolean);
    csv2 = csv[2].split(" ").filter(Boolean);
    csv3 = csv[3].split(" ").filter(Boolean);

      csv4 = [];
      let index_now = 0;
      let part_seq = 1;
      let child_flg = 0 // 子要素の編集中であるフラグ
      let check_radio_seq = 0; // 子要素が所属する親要素の番地
      let check_radio_list = []; // 子要素を格納する配列
      
      let check_radio_title = "";// チェックボックス or ラジオボタンをグループ化するためのタイトル（check_title、radio_titleの値が挿入）
      let group_seq = 0// チェックボックス or ラジオボタンをグループ化するためのシーケンスNo.
      
      for ( const [index, kind] of csv1.entries()) {
        
        csv4[index] = part_seq;
        if (index < index_now) { continue; }
        let newid = allparts.value.length + 1;

        allparts.value.length + 1;
        
        if(kind == "("){
            // 子要素の始まりの場合
            // 1つ前の番地を親要素の番地として保存
            check_radio_seq = allparts.value.length-1
            // フラグを立てる
            child_flg = 1
            continue;
        }else if(kind == ")"){
            // 子要素終了の場合
            // フラグを下ろす
            child_flg = 0
            // 子要素を親要素に格納
            allparts.value[check_radio_seq]["child"] = check_radio_list
            check_radio_seq = 0
            check_radio_list = []
            continue;
        }

    
          // 子要素編集中の場合
          if(child_flg == 1){
            // 属性とラベルを配列に挿入し、表示フラグと全体の番地を加える
            check_radio_list.push([kind,csv2[index],0,index])
            
          }else{
            if(kind == "checkbox" || kind == "radio"){

            }else{
                // チェックボックス、ラジオボタン以外はグループ化するためのタイトルを初期化
                check_radio_title = ""
            }

            switch(kind) {
                case "title_large":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'title_large',
                        label: csv2[index],
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    break;
                case "title":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'title',
                        label: csv2[index],
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    break;
                case "image":
                    let image_options = [];
                    let image_count = 0;
                    for (let i=index+1; i<csv1.length; i++) {
                        if (csv1[i] != 'image_child') {
                          //  index_now = i;
                            break;
                        }
                        image_count++
                        image_options.push({
                          index:(index+image_count)
                        });
                    }

                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'image',
                        label: csv2[index],
                        option: image_options,
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index]),
                    });
                    break;
              
                case "image_child":
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'image_child',
                        label: csv2[index],
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    break;
                case "text":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'text',
                        label: csv2[index],
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    break;
                case "radio_title":
                      check_radio_title = csv2[index]
                      part_seq++;
                      group_seq = part_seq
                      allparts.value.push({
                          index: index,
                          id: newid,
                          kind: 'radio_title',
                          label: csv2[index],
                          seq: "part"+part_seq,
                          hissu: parseInt(csv3[index])
                      });
                      break;
                case "check_title":
                      check_radio_title = csv2[index]
                      part_seq++;
                      group_seq = part_seq
                      allparts.value.push({
                        index: index,
                          id: newid,
                          kind: 'check_title',
                          label: csv2[index],
                          seq: "part"+part_seq,
                          hissu: parseInt(csv3[index])
                      });
                      break;
                case "radio":
                    allparts.value.push({
                      index: index,
                      id: newid,
                      kind: 'radio',
                      label: csv2[index],
                      seq: "part"+part_seq,
                      hissu: parseInt(csv3[index]),
                      title:check_radio_title,
                      group_seq: "part"+group_seq,
                      child:[]
                    });
                    break;
                case "checkbox":
                    part_seq++;
                    allparts.value.push({
                      index: index,
                      id: newid,
                      kind: 'checkbox',
                      label: csv2[index],
                      seq: "part"+part_seq,
                      hissu: parseInt(csv3[index]),
                      title:check_radio_title,
                      group_seq: "part"+group_seq,
                      child:[]
                    });
                    break;
                case "pulldown": 
                    let options = [];
                    for (let i=index+1; i<csv1.length; i++) {
                        if (csv1[i] != 'pulldown_child') {
                            index_now = i;
                            break;
                        }
                        options.push(csv2[i]);
                    }

                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'pulldown',
                        label: csv2[index],
                        option: options,
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    answer.value[index] = "〇"
                    answer.value[index+1] = "〇"
                    break;
                
                case "pulldown_child":
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'pulldown_child',
                        label: csv2[index],
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    break;
                case "measure":{
                    let divide = 0;
                    for (let i=index+1; i<csv1.length; i++) {
                        if (csv1[i] != '') {
                            index_now = i;
                            break;
                        }
                        divide++;
                    }
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'measure',
                        label: csv2[index],
                        label_st: csv2[index+1],
                        label_ed: csv2[index_now-1],
                        divide: divide-2,
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    index_now = index+3;
                    break;}
                case "date":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'date',
                        label: csv2[index],
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    break;
                case "time":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'time',
                        label: csv2[index],
                        seq: "part"+part_seq,
                        hissu: parseInt(csv3[index])
                    });
                    break;
                case "imageup":
                    break;
                case "fileup":
                    break;
                case "line":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'line',
                        seq: "part"+part_seq
                    });
                    break;
                      
                case "実施":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: '実施',
                        seq: "part"+part_seq
                    });
                  break;
                  
                case "form_title":
                    part_seq++;
                    let set_title = csv2[index];
                    if(csv2[index] == "未入力"){
                      set_title = ""
                    }
                    allparts.value.push({
                        index: index,
                        id: newid,
                        label: set_title,
                        kind: 'form_title',
                        seq: "part"+part_seq
                    });
                  break;
                case "form_sub_title":
                    part_seq++;
                    let set_sub_title = csv2[index];
                    if(csv2[index] == "未入力"){
                      set_sub_title = ""
                    }
                    allparts.value.push({
                        index: index,
                        id: newid,
                        label: set_sub_title,
                        kind: 'form_sub_title',
                        seq: "part"+part_seq
                    });
                    break;
                case "footer":
                    part_seq++;
                    let set_footer = csv2[index];
                    if(csv2[index] == "未入力"){
                      set_footer = ""
                    }
                    allparts.value.push({
                        index: index,
                        id: newid,
                        label:set_footer,
                        kind: 'footer',
                        seq: "part"+part_seq
                    });
                    break;
                case "(":
                    break;
                case ")":
                    break;
                case "page":
                    break;
                case "break":
                    part_seq++;
                    allparts.value.push({
                        index: index,
                        id: newid,
                        kind: 'break',
                        seq: "part"+part_seq
                    });
                    break;
            }
          }
      }

    emit('call',{cmd:'page_scroll'})
  }
  
  //-------- 回答レコードを作成する ----------------------------
  let answer = ref([]);
  const setText = (index) => {
     let set_text = answer.value[index].replace(/\n/g, '。');
     set_text = set_text.replace(/,/g, '、');
     set_text = set_text.replace(/ /g, '　');
     answer.value[index] = set_text;
  }
  
  const setDate = (index) => {
    //  answer.value[index] = ans_date.value;
  }
  
  const setTime = (index) => {
 //     answer.value[index] = ans_time.value;
  }
  
  const setCheckbox = (parts,group) => {
        let index = parts.index
          if (ans_checkbox.value[index] == true) {
              answer.value[index] = '〇';
              
            if(parts.child != ""){
              if(csv3[group.index] == 1){
//                alert("親が必須なのでこれも必須です。")
                csv3[parts.child[0][3]] = 1
              }
              parts.child[0][2] = 1

            }
          } else {
              answer.value[index] = '';
              
            if(parts.child != ""){
              csv3[parts.child[0][3]] = 0
                parts.child[0][2] = 0

            }
          }

      }
      
  const setChildCheck = (index,child_index) => {
    
     let set_text = ans_childcheck.value[child_index].replace(/\n/g, '。');
     set_text = set_text.replace(/,/g, '、');
     set_text = set_text.replace(/ /g, '　');
     ans_childcheck.value[child_index] = set_text
    answer.value[index] = ans_childcheck.value[child_index]
  }
  // parts = ラジオボタン本体、group = ラジオボタンが所属するエリア
  const setRadio = (parts,group) => {
        let index = parts.index
          let pseq = csv4[index];
          /**
           * group.seq == parts.group_seq
           */
          for (let i=0;i<csv1.length;i++) {
              if (csv1[i] == 'radio' && csv4[i] == pseq && i != index) {
                  answer.value[i] = '';
              }
          }
          // ラジオボタンの入れ子を全て解除
          for (let a=0;a<allparts.value.length;a++) {
            let radio_button = allparts.value[a]
            if(radio_button.kind == "radio"){
                if(radio_button.kind == "radio"){
                    if(group.seq == radio_button.group_seq){
                        if(radio_button.child != ""){
                            csv3[radio_button.child[0][3]] = 0
                            radio_button.child[0][2] = 0
                        }
                    }
                }
            }
          }

          answer.value[index] = '';
          if (ans_radio.value == 'on') {
            answer.value[index] = '〇';
            
            if(parts.child != ""){
              if(csv3[group.index] == 1){
                //alert("親が必須なのでこれも必須です。")
                csv3[parts.child[0][3]] = 1
              }
              parts.child[0][2] = 1
            }
          }
      }
  
  const setChildRadio = (index,child_index) => {
     let set_text = ans_childradio.value[child_index].replace(/\n/g, '。');
     set_text = set_text.replace(/,/g, '、');
     set_text = set_text.replace(/ /g, '　');
     ans_childradio.value[child_index] = set_text
      answer.value[index] = ans_childradio.value[child_index];
  }
  
  const setMeasure = (pindex,pdivide,index) => {
      for (let i=0;i<pdivide;i++) {
          answer.value[pindex+i] = '';
      }
      answer.value[index] = '〇';
  }
  const setPulldown = (id,index) => {
    const menu = document.getElementById(id);

    let pulldown_name = menu.value
    answer.value[index] = ""
        
    for (let p=index+1;p<csv1.length;p++) {
      if (csv1[p] != 'pulldown_child') {
        break;
      }
      answer.value[p] = ""
      if(csv2[p] == pulldown_name){
        answer.value[index] = "〇"
        answer.value[p] = "〇"
      }
    }
  }
  
// 「ファイルを選択」ボタン押下
/*
let setImage = function(index){
  const file_set = document.getElementById("img"+index)
  file_set.click()
}*/

// 画像ファイル取得
const imgUpload = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    if(file == undefined){
        // ファイルのアップロードを取り消した場合はその番地の回答も空にする
        answer.value[fileInput.id] = null
    }else{
        // ローディングアイコン表示
        emit('call', { cmd:"loading_start" })

        let accept = file.name.split(".")[1]
        let syurui = "report"
        if(form_syurui == 1){
            syurui = "enqete"
        }

        // fileInput.id = 画像inputのindex
        // fileInput.name = 画像フォーム全体のタイトル部のindex
        let file_name = GlobalData.shakyo_code+"_"+syurui+form_no+"_"+fileInput.name+"-"+fileInput.id+"_"+GlobalData.user_id+"."+accept
        
        upload(file, file_name,fileInput.id);
    }
}

let error_count = 0

// ファイルアップロード
function upload (uploadedFile, filename,index) {
    // PROVEDER_KEY作成
    let PROVIDER_KEY = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;
    AWS.config.region = 'ap-northeast-1';
    // IDプールにてIDトークンの認証を行う
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: GlobalData.$IdentityPoolId,
        Logins: {
            [PROVIDER_KEY]: GlobalData.$ID_Token.headers.Authorization,
        }
    });

    //資格情報のリフレッシュ処理
    AWS.config.credentials.refresh((err) => {
      if(err) {
        if(error_count == 5){
          upload_error(index)
        }else{
          error_count++
          setTimeout(function(){upload(uploadedFile, filename,index)},"1000")
        }

        return;
      }
    });
    
    // S3オブジェクト作成
    var s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: 'ap-northeast-1'
    });

    // パラメータ作成
    const params = {
      Bucket: GlobalData.$Image_bucket,
      Key: 'form/'+filename,
    }
    params.Body=uploadedFile;

    return new Promise((resolve, reject) => {
      // S3へオブジェクトをアップロード
      s3.putObject(params, (err, data) => {
        if (err) {
          reject(err)
          upload_error(index)
        } else {
          resolve(data)
          answer.value[index] = filename

        }
        emit('call', { cmd:'loading_end_noreload'})
      })
    })
}

// 画像アップロードに失敗した時
function upload_error(index){
    
      message.value = "画像のアップロードに失敗しました。もう一度お試しください。<br>※画像アップロードは通信環境の良いところで行ってください。";
      message_cat.value = 0;
      message_flag.value = true;
      message_method.value = "get_error";
      contentMessage.value = MessageModal
    answer.value[index] = null
    emit('call', { cmd:'loading_end_noreload'})
}


  
  //-------- CSVに変換する -----------------------
  const csv1_csv = ref('');
  const csv2_csv = ref('');
  const csv3_csv = ref('');
  const answer_csv = ref('');
  let mail_answer = ref('')
  const app = ref('0');
  const teishutsu_kakunin = () => {

    // 必須項目に関するフラグ
    let cr_title_flg = 0 // check_title、radio_title、pulldownの場合は1
    let cr_flg = 0 // チェックボックス、ラジオボタン、プルダウン、画像で必須項目が入力されていれば1
    let error_flg = 0 // 必須項目が未入力の場合1

      csv1_csv.value = csv1[0];
      csv2_csv.value = csv2[0];
      csv3_csv.value = csv3[0];
      answer_csv.value = answer.value[0];

      //alert(csv1.length+"/"+csv2.length+"/"+csv3.length+"/"+answer.length+"/")

      if (answer.value[0] === undefined) { answer_csv.value = ''; }
      for (let i=1;i<csv1.length;i++) {

        // チェックボックスタイトル、ラジオボタンタイトル、プルダウン、画像のフラグが立ってるとき
        if(cr_title_flg == 1){
            if(csv1[i] == "checkbox" || csv1[i] == "radio" || csv1[i] == "pulldown_child" || csv1[i] == "image_child"){
              
                // 回答入力されていたらOKフラグを立てる
                if(answer.value[i] != "" && answer.value[i] != null && answer.value[i] != undefined){

                  if(csv1[i] == "checkbox" || csv1[i] == "radio" ){

                  }
                    cr_flg = 1;
                }
                
            }else if(csv1[i] == "(" ){
              // 子要素の時の始まり
              
              // 一つ前が選択されていた時
              if(answer.value[i-1] != "" && answer.value[i-1] != null && answer.value[i-1] != undefined){
                // 一つ後が回答されているとき
                if(answer.value[i+1] != "" && answer.value[i+1] != null && answer.value[i+1] != undefined){
                  
                  cr_flg = 1;
                }else{
                  // 回答されてなかったらエラー
                  cr_flg = 0;
                  error_flg++
                }

              }

            }else if(csv1[i] == ")" || csv1[i-1] == "("){
              // 子要素の終わり/または1つ前が子要素（スルー）
            }else{
                // チェックボックスタイトル、ラジオボタンタイトル、プルダウン、画像のフラグが立ったまま、それら以外の項目に移動した時

                // 回答入力OKフラグが立っていない場合はエラー
                if(cr_flg == 0){
                    error_flg++
                }
                // フラグ初期化
                cr_flg = 0
                cr_title_flg = 0

            }

        }
        
        // 必須フラグが1（必須）の場合
        if(csv3[i] == 1){
            
            if(csv1[i] == "check_title" || csv1[i] == "radio_title" || csv1[i] == "pulldown" || csv1[i] == "image"){
                cr_title_flg = 1
            }else{
                // チェックボックスタイトル、ラジオボタンタイトル、プルダウン、画像以外は初期化
                cr_title_flg = 0
                

                // 回答が読み取れない場合はエラー
                if(answer.value[i] == "" || answer.value[i] == null || answer.value[i] == undefined){

                    error_flg++
                }
            }

        }
        
        
        
      if((i+1) == csv1.length){
        // チェックボックスタイトル、ラジオボタンタイトル、プルダウン、画像のフラグが立ってるとき
        // 最後のチェックボックス、ラジオボタン、プルダウン選択肢、画像の可能性があるのでそれの必須を判断する
        if(cr_title_flg == 1){

            // 回答入力OKフラグが立っていない場合はエラー
            if(cr_flg == 0){
                error_flg++
            }
            // フラグ初期化
            cr_flg = 0
            cr_title_flg = 0
        }
      }


          csv1_csv.value += ",";
          csv2_csv.value += ",";
          csv3_csv.value += ",";
          if(i != 1) answer_csv.value += ","; // 取り出した値と回答の行では列数が1つ違うので、回答はひとつずらす
          csv1_csv.value += csv1[i];
          csv2_csv.value += csv2[i];
          csv3_csv.value += csv3[i];
          if(csv1[i] == "user_id"){
              //alert(GlobalData.user_id)
              answer_csv.value += GlobalData.user_id;

          }else if(csv1[i] == "program_id"){
            answer_csv.value += program_id;
            
          }else if(csv1[i] == "update_date"){
            
              
              let new_date = new Date()
              let set_date = new_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
              set_date = new Date(set_date);
              set_date.setHours(set_date.getHours() + 9 );
              answer_csv.value += DateSetting(set_date);
          }else{

            if (answer.value[i] === undefined) {
              answer_csv.value += '';
            } else {
              /*
              // テキスト型の場合は改行を削除
              if(csv1[i] == "text"){
                answer_csv.value += set_text
              }else{*/
                answer_csv.value += answer.value[i];
              //}
            }

          //  mail_answer.value[mail_answer.value.length] = [csv2[i],answer.value[i]]
          }

      }

      // 回答を配列に直す
      let answer_array = answer.value
      
      // 一時的に保存するリスト
      let temp_mail_answer = []

      // 実際に送るリスト初期化
      mail_answer.value = ''

      let csv = results.split("\n");
      
      let index_now = 0;
      for ( const [index, kind] of csv1.entries()) {
        if (index < index_now) { continue; }
        let newid = temp_mail_answer.length + 1;

        let set_text = ""
        let csv_row = ""
        switch(kind) {
          
            case "image":
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:"※画像は表示できません。"
                });
                break;
            case "text":
                // １つ前が「（」だったときは終了
                if (csv1[index-1] == '(') {
                    break;
                }
                if(answer_array[index] != "NaN"){
                    set_text = answer_array[index]
                }
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:set_text
                });
                break;
            case "radio_title":
                let radio_text = "";
                let radio_child_array = []
                let radio_child_flg = 0; // 選択肢に子要素がある場合は立てる
                for (let i=index+1; i<csv1.length; i++) {
                    // 子要素フラグが降りていて下記の3種類以外の場合はそこで終了
                    if ((csv1[i] != 'radio' && csv1[i] != '(' && csv1[i] != ')')
                         && radio_child_flg == 0) {
                        break;
                    }
                    
                    if(csv1[i] == '('){
                        radio_child_flg = 1
                    }else if(csv1[i] == ')'){
                        radio_child_flg = 0
                    }else if(csv1[i] == 'radio'){
                      csv_row = answer_array[i]
                      if(csv_row =="〇") {
                        let set_radio_array = []
                        set_radio_array = [csv2[i],'','']
                        // 次の列が子要素だった場合
                        if(csv1[i+1] == '(') {
                          set_radio_array = [csv2[i],csv2[i+2],answer_array[i+2]]
                        }
                        radio_child_array[radio_child_array.length] = set_radio_array
                      }
                    }
                }

                for(let r = 0;r<radio_child_array.length;r++){
                  let radio_row = radio_child_array[r]
                  if(r != 0) radio_text += "<br>"
                  radio_text += radio_row[0]
                  if(radio_row[1] != ''){
                    radio_text += "<br>"+radio_row[1]+"："+radio_row[2]
                  }
                }
                
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:radio_text
                });
                break;
            case "check_title":
                let check_text = [];
                let check_child_array = []
                let check_child_flg = 0; // 選択肢に子要素がある場合は立てる
                for (let i=index+1; i<csv1.length; i++) {
                    // 子要素フラグが降りていて下記の3種類以外の場合はそこで終了
                    if ((csv1[i] != 'checkbox' && csv1[i] != '(' && csv1[i] != ')')
                      && check_child_flg == 0) {
                          break;
                      }
                      if(csv1[i] == '('){
                        check_child_flg = 1
                      }else if(csv1[i] == ')'){
                        check_child_flg = 0
                      }else if(csv1[i] == 'checkbox' ){
                        csv_row = answer_array[i]
                        if(csv_row =="〇") {
                          let set_check_array = []
                          set_check_array = [csv2[i],'','']
                          // 次の列が子要素だった場合
                          if(csv1[i+1] == '(') {
                            set_check_array = [csv2[i],csv2[i+2],answer_array[i+2]]
                          }
                          check_child_array[check_child_array.length] = set_check_array
                        }
                    }
                }

                for(let c = 0;c<check_child_array.length;c++){
                  let check_row = check_child_array[c]
                  if(c != 0) check_text += "<br>"
                  check_text += "・"+check_row[0]
                  if(check_row[1] != ''){
                    check_text += "<br>"+check_row[1]+"："+check_row[2]
                  }
                }
                
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:check_text
                });
                break;
            case "pulldown":
                
                let pulldown_text = "";

                for (let i=index+1; i<csv1.length; i++) {
                    if (csv1[i] != 'pulldown_child') {
                        break;
                    }
                    if(answer_array[i] =="〇") {
                      pulldown_text = csv2[i]
                      //alert(pulldown_text)
                    }
                }
                
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:pulldown_text
                });

                /*
                let radio_text = "";
                let radio_child_array = []
                let radio_child_flg = 0; // 選択肢に子要素がある場合は立てる
                for (let i=index+1; i<csv1.length; i++) {
                    // 子要素フラグが降りていて下記の3種類以外の場合はそこで終了
                    if ((csv1[i] != 'radio' && csv1[i] != '(' && csv1[i] != ')')
                         && radio_child_flg == 0) {
                        break;
                    }
                    
                    if(csv1[i] == '('){
                        radio_child_flg = 1
                    }else if(csv1[i] == ')'){
                        radio_child_flg = 0
                    }else if(csv1[i] == 'radio'){
                      csv_row = answer_array[i]
                      if(csv_row =="〇") {
                        let set_radio_array = []
                        set_radio_array = [csv2[i],'','']
                        // 次の列が子要素だった場合
                        if(csv1[i+1] == '(') {
                          set_radio_array = [csv2[i],csv2[i+2],answer_array[i+2]]
                        }
                        radio_child_array[radio_child_array.length] = set_radio_array
                      }
                    }
                }

                for(let r = 0;r<radio_child_array.length;r++){
                  let radio_row = radio_child_array[r]
                  if(r != 0) radio_text += "<br>"
                  radio_text += radio_row[0]
                  if(radio_row[1] != ''){
                    radio_text += "<br>"+radio_row[1]+"："+radio_row[2]
                  }
                }
                
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:radio_text
                });
                */

                break;
            case "date":
              
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:answer_array[index]
                });
                break;
            case "time":
              
                temp_mail_answer.push({
                    label: csv2[index],
                    set_text:answer_array[index]
                });
                break;
            
            default:
              break;
        }
    }

    // temp_mail_answer配列をmail_answerにテキストとして格納
    for(let t = 0;t<temp_mail_answer.length;t++){
      if(t != 0 ) mail_answer.value += "<br><br>"
      mail_answer.value += "● "+temp_mail_answer[t].label+"<br>"+temp_mail_answer[t].set_text
    }
    
    if(error_flg > 0){
      message.value = "未入力の必須項目があります。";
      message_cat.value = 0;
      message_flag.value = true;
      message_method.value = "get_error";
      contentMessage.value = MessageModal
    }else{
        
      message.value = "提出しますか？";
      message_cat.value = 1;
      message_flag.value = true;
      message_method.value = "teishutsu_kakunin";
      contentMessage.value = MessageModal
        
    }
  }

  const teishutsu  = () => {
    emit('call',{cmd:'cr_answer',answer:answer_csv.value,mail_answer:mail_answer.value,no:form_no,program_id:program_id,syurui:form_syurui_text,syurui_no:form_syurui});
  }


    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる

        if(message_method.value == "not_form"){
          // アンケート・報告書の内容が用意されていないときはマイページに戻す
          location.href = location.protocol+'//'+location.host+'/'+route.params.shakyo+'/Taiken/mypage'
        }else if(message_method.value == "teishutsu_kakunin"){
          teishutsu()
        }

    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }

  
    /* 初期処理 */
    kaito(results);
  </script>
  
  <style scoped>
  td {
      border: none;
  }
    
    .answer_area div{
    width:100%
    }

    .answer_area div textarea{
    width:100%
    }

    .section_area{
    background-color: white;
        box-shadow: 1px 1px 3px black;
        padding: 1rem;
            margin-bottom: 22px;
            font-size:0.95rem;
        border-radius: 5px;
    }


    .section_area input[type=radio]{
    background-color: #eeeeee;
    }
    .section_area input:checked[type=radio]{
    background-color: blue;
    }
.title_set {
  padding-left:0
}

  </style>
  